import { useEffect, useState } from 'react';
import styles from './TypewriterText.module.sass';

interface TypewriterTextProps {
  text: string;
  speed?: number;
  onComplete: () => void;
}

export const TypewriterText = ({
  text,
  speed = 40,
  onComplete,
}: TypewriterTextProps) => {
  const [visibleLength, setVisibleLength] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    setVisibleLength(0);
    setIsComplete(false);
  }, [text]);

  useEffect(() => {
    if (text.length === 0) {
      setIsComplete(true);
      onComplete();
      return;
    }
    if (visibleLength >= text.length) {
      setIsComplete(true);
      onComplete();
      return;
    }

    const timer = setTimeout(() => {
      setVisibleLength((prev) => prev + 1);
    }, speed);

    return () => clearTimeout(timer);
  }, [visibleLength, text.length, speed, onComplete]);

  return (
    <span className={styles.text}>
      {text.slice(0, visibleLength)}
      {!isComplete && <span className={styles.cursor} />}
    </span>
  );
};
